import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import AppShell from './AppShell'
import OrgDashboards from './routes/OrgDashboards'
import Trash from './routes/Trash'
import DashboardView from './routes/DashboardView'
import DashboardPreview from './routes/DashboardPreview'
import HomeRedirect from './routes/HomeRedirect'
import SharedView from './routes/SharedView'
import Members from './routes/Members'
import Events from './routes/Events'
import RacePlan from './routes/RacePlan'
import Team from './routes/Team'
import Join from './routes/Join'
import NewOrg from './routes/NewOrg'

/**
 * A data router rather than <BrowserRouter>, matching the admin app and for the
 * same reason: useBlocker — which is what stops a navigation away from an
 * unsaved dashboard layout — exists only on one.
 *
 * Built once at module scope. Rebuilding it on every render would remount the
 * whole tree and lose exactly the state the guard is there to protect.
 */
const router = createBrowserRouter([
  // Outside AppShell deliberately: the public share view must have no code path
  // that could reach organisation data, not merely a check that stops it.
  { path: 's/:token', element: <SharedView /> },
  // Also outside the shell, for the opposite reason: it reads nothing at all,
  // so it needs neither an identity nor an organisation.
  { path: 'preview', element: <DashboardPreview /> },
  {
    element: <AppShell />,
    children: [
      { index: true, element: <HomeRedirect /> },
      { path: 'o/:orgId', element: <OrgDashboards /> },
      { path: 'o/:orgId/trash', element: <Trash /> },
      { path: 'o/:orgId/people', element: <Members /> },
      { path: 'o/:orgId/events', element: <Events /> },
      { path: 'o/:orgId/events/:eventId/plan', element: <RacePlan /> },
      { path: 'o/:orgId/team', element: <Team /> },
      // Inside the shell: joining needs an identity to attach the membership
      // to, so signing in comes first.
      { path: 'join/:token', element: <Join /> },
      { path: 'organisations/new', element: <NewOrg /> },
      { path: 'd/:dashboardId', element: <DashboardView /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])

export default function App() {
  return <RouterProvider router={router} />
}
